import * as React from "react";
import "./style.css";
import { cardData } from "../../Data/cardData";

import TableRestaurantOutlinedIcon from "@mui/icons-material/TableRestaurantOutlined";
import BlenderOutlinedIcon from "@mui/icons-material/BlenderOutlined";
import LightOutlinedIcon from "@mui/icons-material/LightOutlined";
import CottageOutlinedIcon from "@mui/icons-material/CottageOutlined";
import LaptopMacOutlinedIcon from "@mui/icons-material/LaptopMacOutlined";
import WatchOutlinedIcon from "@mui/icons-material/WatchOutlined";
import slugify from "../../Utils/slugify";
export default function ProductNav() {
  const iconsMap = {
    BlenderOutlinedIcon,
    TableRestaurantOutlinedIcon,
    LightOutlinedIcon,
    CottageOutlinedIcon,
    LaptopMacOutlinedIcon,
    WatchOutlinedIcon,
  };

  const [openCategory, setOpenCategory] = React.useState(null);
  const [openSubFamily, setOpenSubFamily] = React.useState(null);
  const [openThirdLevel, setOpenThirdLevel] = React.useState(null);

  const [path1, setPath1] = React.useState("");
  const [path2, setPath2] = React.useState("");
  const [path3, setPath3] = React.useState("");
  const [path4, setPath4] = React.useState("");

  React.useEffect(() => {
    const parts = decodeURIComponent(window.location.pathname).split("/");

    setPath1(parts[2] || "");
    setPath2(parts[3] || "");
    setPath3(parts[4] || "");
    setPath4(parts[5] || "");
  }, []);

const handleCategoryClick = (index, category) => {
  if (category.redirectTo) {
    window.location.href = `/collections/${category.redirectTo}`;
    return;
  }

  setOpenCategory(openCategory === index ? null : index);
  setOpenSubFamily(null);
  setOpenThirdLevel(null);
};

 const handleSubFamilyClick = (catIndex, subIndex, subItem) => {
  const hasChildren = subItem.sousFamilles?.length > 0;

  const categorySlug = slugify(cardData[catIndex].title);
  const subSlug = slugify(subItem.nom);

  if (!hasChildren) {
    window.location.href = `/collections/${categorySlug}/${subSlug}`;
    return;
  }

  const key = `${catIndex}-${subIndex}`;
  setOpenSubFamily(openSubFamily === key ? null : key);
  setOpenThirdLevel(null);
};

  const toggleThirdLevel = (key) => {
    setOpenThirdLevel(openThirdLevel === key ? null : key);
  };
  const findCategoryBySlug = (slug) =>
  cardData.find((c) => slugify(c.title) === slug);

const findSubFamilyBySlug = (category, slug) =>
  category?.sousFamille?.find((s) => slugify(s.nom) === slug);

const findSubSubFamilyBySlug = (subFamily, slug) =>
  subFamily?.sousFamilles?.find((s) => slugify(s.nom) === slug);

const findSubSubSubFamilyBySlug = (subSubFamily, slug) =>
  subSubFamily?.sousSousFamilles?.find((s) => slugify(s.nom) === slug);
const category = findCategoryBySlug(path1);
const sub = findSubFamilyBySlug(category, path2);
const subSub = findSubSubFamilyBySlug(sub, path3);
const subSubSub = findSubSubSubFamilyBySlug(subSub, path4);
  return (
    <div className="productNav">

      {/* ================= BREADCRUMB SIMPLE (SAFE) ================= */}
     <div className="navbarCollection">
  <a href="/collections">collections</a>

  {category && (
    <>
      {" / "}
      <a href={`/collections/${slugify(category.title)}`}>
        {category.title}
      </a>
    </>
  )}

  {sub && (
    <>
      {" / "}
      <a href={`/collections/${slugify(category.title)}/${slugify(sub.nom)}`}>
        {sub.nom}
      </a>
    </>
  )}

  {subSub && (
    <>
      {" / "}
      <a
        href={`/collections/${slugify(category.title)}/${slugify(sub.nom)}/${slugify(subSub.nom)}`}
      >
        {subSub.nom}
      </a>
    </>
  )}

  {subSubSub && (
    <>
      {" / "}
      <a
        href={`/collections/${slugify(category.title)}/${slugify(sub.nom)}/${slugify(subSub.nom)}/${slugify(subSubSub.nom)}`}
      >
        {subSubSub.nom}
      </a>
    </>
  )}
</div>

      {/* ================= CATEGORY ================= */}
      <ul className="categoryList">
        {cardData.map((category, catIndex) => (
          <li key={catIndex}>

            <div
              className={`categoryTitle ${path1 === category.title ? "select" : ""}`}
              onClick={() => handleCategoryClick(catIndex, category)}
            >
              {category.title}
            </div>

            {/* ================= SUB ================= */}
            {openCategory === catIndex && category.sousFamille?.length > 0 && (
              <ul className="subFamilyList">

                {category.sousFamille.map((subItem, subIndex) => {
                  const subKey = `${catIndex}-${subIndex}`;
                  const hasChildren = subItem.sousFamilles?.length > 0;

                  return (
                    <li key={subIndex}>

                      <div
                        className={`subfamilyItem1 ${path2 === subItem.nom ? "select" : ""}`}
                        onClick={() =>
                          handleSubFamilyClick(catIndex, subIndex, subItem)
                        }
                      >
                        {iconsMap[subItem.iconName] &&
                          React.createElement(iconsMap[subItem.iconName], {
                            fontSize: "small",
                            style: { marginRight: 8 },
                          })}

                        {subItem.nom} {hasChildren && " ▸"}
                      </div>

                      {/* ================= LEVEL 3 ================= */}
                      {hasChildren && openSubFamily === subKey && (
                        <ul className="subSubFamilyList">

                          {subItem.sousFamilles.map((sf, sfIndex) => {
                            const thirdKey = `${subKey}-${sfIndex}`;
                            const hasSubSub = sf.sousSousFamilles?.length > 0;
const catSlug = slugify(category.title);
const subSlug = slugify(subItem.nom);
const sfSlug = slugify(sf.nom);
                            return (
                              <li key={sfIndex}>

                                {/* LEVEL 3 SIMPLE */}
                                {!hasSubSub && (
                                  
                                  <a
                                  
                                   href={`/collections/${catSlug}/${subSlug}/${sfSlug}`}
                                    className={`subfamilyItem2 ${path3 === sf.nom ? "select" : ""}`}
                                  >
                                    {sf.nom}
                                  </a>
                                )}

                                {/* LEVEL 3 WITH CHILDREN */}
                                {hasSubSub && (
                                  <>
                                    <div
                                      className={`subfamilyItem2 ${path3 === sf.nom ? "select" : ""}`}
                                      onClick={() => toggleThirdLevel(thirdKey)}
                                    >
                                      {sf.nom} ▸
                                    </div>

                                    {/* ================= LEVEL 4 ================= */}
                                    {openThirdLevel === thirdKey && (
                                      <ul className="subSubSubList">

                                        {sf.sousSousFamilles.map((subSub, idx) => (
                                          <li key={idx}>
                                            <a
                                              href={`/collections/${catSlug}/${subSlug}/${sfSlug}/${slugify(subSub.nom)}`}
                                              className={`subfamilyItem3 ${path4 === subSub.nom ? "select" : ""}`}
                                            >
                                              {subSub.nom}

                                              {(subSub.nom === "maternité" ||
                                                subSub.nom === "orthopedie") 
                                              }
                                            </a>
                                          </li>
                                        ))}

                                      </ul>
                                    )}
                                  </>
                                )}

                              </li>
                            );
                          })}

                        </ul>
                      )}

                    </li>
                  );
                })}

              </ul>
            )}

          </li>
        ))}
      </ul>
    </div>
  );
}